import { shallowRef } from 'vue';
import type { IOdds } from '@/interface/IOdds';
import type { MarketType } from '@/interface/enum';
import { buildMarketPointOrder } from '@/libraries/oddsApi/betBuilderMarketOrder';
import { defineContext } from '@/libraries/utils/defineContext';

export const SboMarketPointOrderContext = defineContext('SboMarketPointOrder', () => {
    const order = shallowRef<Map<MarketType, string[]>>(new Map());

    function record(odds: IOdds[]) {
        const merged = new Map(order.value);
        buildMarketPointOrder(odds).forEach((points, mt) => merged.set(mt, points));
        order.value = merged;
    }

    return { order, record };
});
